export default "__VITE_ASSET__WkPpY2tN__"